<template>
	<div v-if="show" class="animated fadeIn">
		<el-container class="fast-word-pannel">
			<el-header class="fast-word-pannel__header" height="55px">
				<p>快捷话术</p>
				<p class="tools">
					<i class="el-icon-close" @click="closeBox" />
				</p>
			</el-header>
			<el-main class="fast-word-pannel__main">
				<div class="search">
					<label>快捷搜索：</label>
					<el-input size="mini" placeholder="搜索关键词" v-model="searchVal" clearable 
					@keyup.enter.native="toSearch"></el-input>
					<el-button @click="toSearch" type="primary" size="mini" class="btn">查询</el-button>
				</div>
				<div class="lists">
					<TreeBox @handleTreeClick="handleTreeClick" ref="fastwordTree"></TreeBox>
				</div>
			</el-main>

		</el-container>
	</div>
</template>
<script>
	import TreeBox from '@/views/system/fastWords/tree.vue';
	import { isCanSend } from '@/utils/imService';
	export default {
		components:{
			TreeBox
		},
		model: {
			prop: 'show',
			event: 'close',
		},
		props:{
			show:{
				default:false,
				type:Boolean
			},
		},
		data() {
			return {
				searchVal:''
			}
		},
		methods: {
			closeBox() {
				this.$emit('close', false)
			},
			handleTreeClick(source){
				if(!source.type || source.type == 'more') return;
				if(!isCanSend(this.$store.state.imChatService.index_infos.channel,source.type)) return this.$message.error('抱歉，该渠道禁止发送此类型消息');
				this.$emit('confirm',source);
				
			},
			toSearch(){
				this.$refs.fastwordTree.toSearch(this.searchVal)
			}
		},
	}
</script>
<style lang="scss" scoped>
	.fast-word-pannel {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		font-size: 12px;
		color: #3c4353;
		background-color: #fff;
		z-index: 99;
		&__header {
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1px solid #d8d8d8;
			font-size: 14px;
			font-weight: bold;
			.tools {
				font-size: 20px;
				cursor: pointer;
				
			}
		}
		&__main {
			height: calc(100% - 55px);
			overflow: hidden;
			.search {
				display: flex;
				align-items: center;
				label {
					width: 70px;
					display: inline-block;
					font-weight: 400;
					flex-shrink: 0;
				}
				.btn {
					width: 60px;
					margin-left: 10px;
					flex-shrink: 0;
				}
			}
			.lists {
				height: calc(100% - 100px);
				overflow: auto;
				margin: 20px 0;
				
			}
		}
		
	}
</style>
